import React from 'react'
import { Link } from 'react-router-dom';

function PolicyLinks() {
    return (
        <div>
            <div className="policy-links">
                <Link to="/About.html">
                    About
                </Link>
                <Link to="/PrivacyPolicy.html">
                    Privacy
                </Link>
                <Link to="/CookiePolicy.html">
                    Cookie
                </Link>
                <Link to="/Contact.html">
                    Contact
                </Link>
            </div>
        </div>
    );
}

export default PolicyLinks
